






































import {Component, Emit, Prop, PropSync, Vue} from "vue-property-decorator";
import moment from "moment";
import {PickingList} from "@/interfaces/entity";
import {PickingListStore} from "@/modules/pickinglists";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import EnumLabel from "@/shared/components/EnumSelector/components/Label.vue";
import {PickingListType} from "@/enums/type/pickinglisttype";
import {FORMAT_DATE_TIME_PICKER, PAGE_SIZE_OPTIONS} from "@/shared/constant";

@Component({
    name: "PickingListTable",
    components: {EnumLabel}
})
export default class extends mixins(CommonMixin) {
    PickingListType = PickingListType;
    moment = moment;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;
    columns = [
        {
            title: "Thao tác",
            dataIndex: "id",
            key: "action",
            scopedSlots: { customRender: "action" },
            width: 200
        },
        {
            title: "Mã xuất kho",
            dataIndex: "code",
            key: "code",
            width: 120
        },
        {
            title: "Ngày tạo",
            dataIndex: "createdDate",
            key: "createdDate",
            width: 100
        },
        {
            title: "Ngày chỉnh sửa",
            dataIndex: "updatedDate",
            key: "updatedDate",
            width: 100
        },
        {
            title: "Kho xuất",
            dataIndex: "postOfficeFromRowGuid",
            key: "postOfficeFromRowGuid",
            scopedSlots: { customRender: "postOfficeFrom" },
            width: 100
        },
        {
            title: "NV xuất kho",
            dataIndex: "acceptedByRowGuid",
            key: "acceptedByRowGuid",
            scopedSlots: { customRender: "acceptedBy" },
            width: 120
        },
        {
            title: "NV giao nhận",
            dataIndex: "employeeRowGuid",
            key: "employeeRowGuid",
            scopedSlots: { customRender: "employee" },
            width: 120
        },
        {
            title: "Kho nhận",
            dataIndex: "postOfficeToRowGuid",
            key: "postOfficeToRowGuid",
            scopedSlots: { customRender: "postOfficeTo" },
            width: 150
        },
        {
            title: "Trọng lượng",
            dataIndex: "weight",
            key: "weight",
            width: 100
        },
        {
            title: "Số kiện",
            dataIndex: "boxQuantity",
            key: "boxQuantity",
            width: 100
        },
        {
            title: "Bảng kê",
            dataIndex: "type",
            key: "type",
            scopedSlots: { customRender: "type" },
            width: 100
        }
    ];

    @PropSync("dataSource",{ required: true}) syncDataSource!: Array<PickingList>;
    @PropSync("selectedIds", { type: Array }) syncSelectedIds!: Array<number>;
    @Prop({ type: Boolean, default: false }) readonly hasRowSelection!: boolean;
    @Prop({ type: Boolean, default: false }) readonly hasAction!: boolean;

    get rowSelection() {
        return { selectedRowKeys: this.syncSelectedIds, onChange: this.onSelectChange };
    }

    onSelectChange(selectedRowKeys: any) {
        this.syncSelectedIds = selectedRowKeys;
    }

    get pagination(): object {
        return {
            current: PickingListStore.meta?.page,
            pageSize: PickingListStore.meta?.limit,
            total: PickingListStore.meta?.total,
            showTotal: (total: number) => `Tổng cộng ${total} vận đơn`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    @Emit("onChangePage")
    onChangePage(pagination: any) {
        return pagination;
    }

    @Emit("see-detail")
    seeDetail(id: number) {
        return id;
    }

    @Emit("print")
    print(id: number) {
        return id;
    }
}
